import type errors from '../locales/no/errors.json'

type ErrorKey = keyof typeof errors

// Norwegian FastAPI `detail` strings the UI can show, mapped to their key in
// the `errors` namespace. Taken from the backend's HTTPException calls; the
// backend itself is not changed (#714). Details already in English, or
// bilingual "Norsk / English", need no entry.
export const KNOWN_DETAILS: Record<string, ErrorKey> = {
  'Merke ikke funnet.': 'brandNotFound',
  'Markedsområde ikke funnet.': 'marketAreaNotFound',
  'Aktøren finnes ikke': 'actorNotFound',
  'Ugyldig organisasjonsnummer': 'invalidOrgNumber',
  'Ugyldig eller utløpt tilbakestillingslenke. Vennligst be om en ny lenke.': 'invalidResetLink',
  'Ugyldig bildetype. Tillatte typer: PNG, JPG, GIF, WebP': 'invalidImageType',
  'Bildet er for stort. Maks størrelse er 5 MB.': 'imageTooLarge',
  'tidligst må være en ISO-dato': 'earliestMustBeIsoDate',
  'Maks 5 merker tillatt': 'maxFiveBrands',
  'Kunne ikke sende tilbakemelding. Vennligst prøv igjen senere.': 'feedbackFailed',
  'Kunne ikke sende forespørselen. Vennligst prøv igjen senere.': 'requestFailed',
  'Ingen postnummer konfigurert for din bruker. Kontakt administrator.': 'noPostnummer',
  'For mange forespørsler. Vennligst vent litt før du prøver igjen.': 'tooManyRequests',
  'En feil oppstod under tilbakestilling av passord. Vennligst prøv igjen.': 'resetPasswordFailed',
  'Du må godta abonnementsvilkårene for å sende forespørselen.': 'mustAcceptTerms',
  'dtg støttes ikke for understellsnummer — bruk kjennemerke eller kuid': 'dtgNotSupportedForVin',
  'Ingen aktive biler': 'heftelseNoCars',
}

// Details built with an f-string. Named groups become interpolation values.
export const KNOWN_DETAIL_PATTERNS: [RegExp, ErrorKey][] = [
  [/^Et område med navnet (?<name>.+) finnes allerede\.$/, 'areaNameExists'],
  [/^Merket (?<brand>.+) er allerede lagt til\.$/, 'brandAlreadyAdded'],
  [/^Maks (?<max>\d+) merker per bruker\.$/, 'maxBrandsPerUser'],
  [/^Ukjent modell: (?<model>.+)$/, 'unknownModel'],
  [/^Ukjent merke: (?<brand>.+)$/, 'unknownBrand'],
  [/^Teknisk oppslag er ikke konfigurert: (?<missing>.+) mangler$/, 'tekniskNotConfigured'],
  [/^Heftelsesoppslag er ikke konfigurert: (?<missing>.+) mangler$/, 'heftelseNotConfigured'],
  [/^Over (?<max>\d+) aktive biler$/, 'heftelseTooManyCars'],
  [/^Sjekket nylig, kan sjekkes igjen (?<dato>\S+)$/, 'heftelseRecentlyChecked'],
  [/^Brreg svarte ikke for (?<feilet>\d+) av (?<totalt>\d+) biler\. Ingenting er lagret — prøv igjen\.$/, 'heftelseBrregFailed'],
]
